"use strict";
var MovingDirection;
(function (MovingDirection) {
    MovingDirection[MovingDirection["None"] = 0] = "None";
    MovingDirection[MovingDirection["Left"] = 1] = "Left";
    MovingDirection[MovingDirection["Right"] = 2] = "Right";
})(MovingDirection = exports.MovingDirection || (exports.MovingDirection = {}));
